import React from "react";

const ASP_AdRotator = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP AdRotator</h1>
      <p>This is the ASP AdRotator page content.</p>
    </div>
  );
};

export default ASP_AdRotator;
